import {Component} from 'react';
import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import Label from './Label';

const SubmitLabel = gettext('Reset');
const ErrorMessage = gettext('Please select at least one interest.');

const Form = ({interests, action, intro, error, onChange, onSubmit}) => (
    <form action={action} method="post" onSubmit={onSubmit}>
        {intro && <p><strong>{intro}</strong></p>}
        {error && <p className="error">{error}</p>}
        {interests.map(interest => (
            <Label
                {...interest}
                key={interest.id}
                onChange={onChange}
            />
        ))}
        <input
            type="submit"
            className="submit"
            value={SubmitLabel}
            onClick={onSubmit}
        />
    </form>
);

class FormWrapper extends Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        const {interests} = props;

        const state = this.state = {
            error: null,
        };

        interests.forEach(({id, checked}) => {
            state[id] = checked;
        });
    }

    render() {
        const {error} = this.state;

        return (
            <Form
                {...this.props}
                error={error}
                interests={this.interests}
                onChange={this.handleChange}
                onSubmit={this.handleSubmit}
            />
        );
    }

    get interests() {
        const {interests} = this.props;

        return interests.map(interest => {
            const checked = this.state[interest.id];

            return {
                ...interest,
                checked,
            };
        });
    }

    handleChange(id, checked) {
        this.setState({
            [id]: checked,
        });
    }

    handleSubmit() {
        const {action, CSRFMiddlewareToken: csrfmiddlewaretoken} = this.props;
        const interests = this.interests.filter(({checked}) => checked).map(({id}) => id);

        if (interests.length === 0) {
            return this.handleError(ErrorMessage);
        }

        jQuery.ajax(action, {
            method: 'POST',
            dataType: 'text',
            traditional: true,
            data: {
                csrfmiddlewaretoken,
                interests,
            },
            success: () => {
                window.location.reload(true);
            },
            error: (response, status, error) => {
                this.handleError(String(error || status));
            }
        });
    }

    handleError(error) {
        this.setState({error});
    }

}

const mapStateToProps = ({resetFavouritesURL, CSRFMiddlewareToken, interests}) => ({
    action: resetFavouritesURL,
    CSRFMiddlewareToken,
    interests,
});

export default connect(mapStateToProps)(FormWrapper);
